import { useEffect } from "react";
import { Link } from "react-router-dom";
import Lenis from "lenis";
import { useAskbox } from "@/lib/askbox";
import { Nav } from "@/physio-demo/Nav";
import { Hero } from "@/physio-demo/Hero";
import { Marquee } from "@/physio-demo/Marquee";
import { Manifesto } from "@/physio-demo/Manifesto";
import { Services } from "@/physio-demo/Services";
import { HoursLocation } from "@/physio-demo/HoursLocation";
import { Insurance } from "@/physio-demo/Insurance";
import { Book } from "@/physio-demo/Book";
import { Footer } from "@/physio-demo/Footer";

const FONTS =
    "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;1,400;1,500&family=Plus+Jakarta+Sans:wght@300;400;500;600&family=Syne:wght@400;500;600;700;800&display=swap";

export default function AskboxDemoPage() {
    useAskbox({
        brain: "/widgets/askbox/clinic-brain.json",
        mode: "float",
        openDesktop: true,
    });

    useEffect(() => {
        document.title = "Physio on Elm — demo clinic";
        document.body.classList.add("askbox-demo");

        let link = document.querySelector("link[data-physio-fonts]");
        if (!link) {
            link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = FONTS;
            link.dataset.physioFonts = "true";
            document.head.appendChild(link);
        }

        const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
        window.__lenis = lenis;
        const anchors = document.querySelectorAll('a[href^="#"]');
        const onClick = (e) => {
            const id = e.currentTarget.getAttribute("href");
            const target = document.querySelector(id);
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -96 });
            }
        };
        anchors.forEach((a) => a.addEventListener("click", onClick));

        const onHash = () => {
            if (!window.location.hash) return;
            const target = document.querySelector(window.location.hash);
            if (target) lenis.scrollTo(target, { offset: -96 });
        };
        window.setTimeout(onHash, 120);
        window.addEventListener("hashchange", onHash);

        return () => {
            document.title = "SalesCan";
            document.body.classList.remove("askbox-demo");
            anchors.forEach((a) => a.removeEventListener("click", onClick));
            window.removeEventListener("hashchange", onHash);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div
            className="min-h-screen bg-bone text-ink font-jakarta"
            data-testid="askbox-demo-page"
        >
            <div className="physio-grain" aria-hidden="true" />
            <div className="fixed top-0 left-0 right-0 z-[60] bg-ink px-4 py-2.5 text-center text-xs text-bone sm:text-sm">
                Fictional demo clinic — not a real practice. The orange button is a live Askbox.{" "}
                <Link to="/askbox" className="underline underline-offset-2 hover:text-white">
                    Back to Askbox
                </Link>
            </div>
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Manifesto />
                <Services />
                <HoursLocation />
                <Insurance />
                <Book />
            </main>
            <Footer />
        </div>
    );
}
